//Replaces widget-loader.component.ts
import { LoaderListBullets } from "pro-features/components/Loaders/src/LoaderListItems";
import { SpinnerLoading } from "app/components/spinner-loading/SpinnerLoading";
import type { IWidget } from "app/components/widget/widget-types/Widget";
import { i18nFilter } from "app/filters/i18nFilter";
import type { FC } from "react";

interface INewWidgetLoader {
    widget: IWidget<any>;
}

export const NewWidgetLoader: FC<INewWidgetLoader> = (props) => {
    const { widget } = props;

    const widgetProperties = widget.widgetConfig?.properties ?? {};
    const i18n = i18nFilter();

    const bigTable = /Table/.test(widget.type) && /widgetTable/.test(widget.viewOptions.cssClass);
    const longLoader = widgetProperties.longLoader;
    const loaderTitle = i18n(widgetProperties.loaderTitle);
    const loaderSubtitle = i18n(widgetProperties.loaderSubtitle);

    return (
        <div
            style={{
                position: "relative",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
            }}
        >
            {!bigTable ? (
                <div
                    style={{
                        position: "relative",
                        width: 1,
                        height: 1,
                        left: "50%",
                        top: "-5%",
                        transform: "translate(-50%, -45%)",
                    }}
                >
                    {!longLoader ? <SpinnerLoading top="-10px" /> : null}
                    {longLoader ? (
                        <LoaderListBullets
                            title={loaderTitle}
                            subtitle={loaderSubtitle}
                        />
                    ) : null}
                </div>
            ) : null}
            {bigTable ? (
                <div
                    style={{
                        position: "relative",
                        left: "50%",
                        transform: "translate(-50%, 0)",
                        padding: "0 20",
                    }}
                >
                    <img
                        // src={AssetsService.assetUrl("/images/phone-data.svg")}
                        src={"/app/components/widget-loader/table-big.svg"}
                        alt="table-big"
                    />
                </div>
            ) : null}
        </div>
    );
};
